const $ = jQuery.noConflict();

'use strict';

const BlogSearch = {
	$domSearchResults: null,
	$domSearchResultsList: null,
	$domSearchNoResults: null,
	$domSearchLoader: null,
	postType: null,
	searchTimeout: null,

	init: function() {
		if ($('.js-blog').length === 0) {
			return;
		}
		this.initValues();
		this.bindEvents();
	},

	initValues: function() {
		BlogSearch.$domSearchResults = $('.topics__search-dropdown');
		BlogSearch.$domSearchResultsList = $('.topics__search-results');
		BlogSearch.$domSearchNoResults = $('.topics__search-no-results');
		BlogSearch.$domSearchLoader = $('.js-blog-search-loader');
		BlogSearch.postType = window.fwsPostType || 'post';
	},

	bindEvents: function() {
		$(document).on('input', '#blog-search', function() {
			BlogSearch.searchAutocompleteEvent(this);
		});
		$(document).on('click', function(e) {
			if (!$(e.target).closest('.topics__search').length) {
				if (BlogSearch.$domSearchResults) BlogSearch.$domSearchResults.hide();
			}
		});
	},

	searchAutocompleteEvent: function(el) {
		const value = $(el).val();

		clearTimeout(BlogSearch.searchTimeout);

		if (value.length < 3) {
			if (BlogSearch.$domSearchResults) BlogSearch.$domSearchResults.hide();
			return;
		}
		BlogSearch.$domSearchLoader.addClass('is-active');
		BlogSearch.$domSearchResultsList.hide().html('');
		BlogSearch.$domSearchNoResults.hide();
		BlogSearch.$domSearchResults.show();

		// ajax handler
		BlogSearch.searchTimeout = setTimeout(() => {
			$.ajax({
				method: 'POST',
				url: window.fwsLocalized.ajaxUrl,
				data: {
					action: 'search-autocomplete',
					search: value,
					postType: BlogSearch.postType
				},
				success: function(response) {
					BlogSearch.$domSearchLoader.removeClass('is-active');
					if (response.success && response.data.length > 0) {
						let html = '';
						response.data.forEach(item => {
							html += `
							  <li>
								 <a href="${item.url}">
									<div class="topics__search-image-wrapp">
									   <img src="${item.image}" class="search-result-image" loading="lazy" alt="${item.title}">
									</div>
									<span class="search-result-title">${item.title}</span>
								 </a>
							  </li>`;
						});
						BlogSearch.$domSearchResultsList.html(html).show();
						BlogSearch.$domSearchNoResults.hide();
					} else {
						BlogSearch.$domSearchResultsList.hide().html('');
						BlogSearch.$domSearchNoResults.show();
					}
				},
				error: function() {
					BlogSearch.$domSearchLoader.removeClass('is-active');
				}
			});
		}, 400);
	},
};

export default BlogSearch;
